/**
 * @fileoverview DashboardPreview Component
 * 
 * This component provides a preview of the dashboard interface with customizable 
 * banner image and logo. It uses URL parameters to display different branding elements
 * allowing the preview of client-specific UI configurations.
 * 
 * Key features:
 * - Dynamically loads banner image and logo from URL parameters
 * - Falls back to default images if parameters are not provided
 * - Displays a welcome message with placeholder user name
 */
import React, { useEffect, useState } from "react";
import { Navbar, NavbarContent } from "@eightfold.ai/octuple";
/**
 * DashboardPreview Component
 * 
 * Renders a preview of the dashboard with customizable branding elements.
 * Used for previewing client-specific UI configurations.
 * 
 * @returns {JSX.Element} DashboardPreview component
 */
const DasboardPreview = () => {
  // State for storing the banner image URL
  const [bannerImg, setBannerImg] = useState<any>("");

  // State for storing the header logo image URL
  const [headerImg, setHeaderImg] = useState<any>("");

  /**
   * On component mount, set the banner and header images based on URL parameters
   * or fall back to default images if parameters are not provided
   */
  useEffect(() => {
    // Parse URL parameters inside useEffect to avoid dependency issues
    const urlParams = new URLSearchParams(new URL(window.location.href).search);

    // Set banner image from URL parameter or use default
    if (urlParams?.get('bannerImg')) {
      setBannerImg(urlParams?.get('bannerImg'));
    } else {
      setBannerImg('./../assets/img/HeaderBackground.png');
    }

    // Set header logo from URL parameter or use default
    if (urlParams?.get('logoIcon')) {
      setHeaderImg(urlParams?.get('logoIcon'));
    } else {
      setHeaderImg('./../assets/img/HlabsHeaderLogo.png');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="mainWrapper">
      <div className="dashboardPage">
        {/* Header section with logo and title */}
        <div className="authHeader">
          <Navbar classNames="authHeaderLogo">
            <NavbarContent>
              {/* Conditional rendering of logo or fallback title */}
              {headerImg ?
                <div className='headerLogo'>
                  <div className="dynamicHeader">
                    <img className="dynamicHeaderLogo" alt="header-image" src={headerImg} />
                  </div>
                  <div className='dividerHeader'></div>
                </div>
                :
                <h4 className="authHeaderTitle">Logo</h4>
              }
              <div className='authDividerHeader'></div>
              <h4 className='headerTitle'>Leader Portal</h4>
            </NavbarContent>
          </Navbar>
        </div>
        {/* Banner section with welcome message */}
        <div className="authHeaderBanner" style={{ background: `url(${bannerImg}) no-repeat` }}>
          <div className="authHeaderBannerContent">
            <p className="authHeaderBannerWelcomeContent">Welcome,</p>
            <h2 className="header2Style">Leader Name</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DasboardPreview;